export default __webpack_public_path__ + "static/media/martin_cheetos.24ee246f.jpg";